import React, { useState } from 'react'
import Layout from 'src/features/Layout'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import AllMember from './All'
import NewMember from './New'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={2}>{children}</Box>}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
}

const useStyles = makeStyles((theme) => ({
  title: { marginBottom: theme.spacing(2) },
}))

function Index() {
  const classes = useStyles()

  const [tabState, setTabState] = useState('all')
  const handleChangeTab = (tab, newValue) => {
    setTabState(newValue)
  }

  return (
    <Layout>
      <Box component={Paper} p={2} pt={3} elevation={0}>
        <Typography variant="h5" className={classes.title}>
          Member Management
        </Typography>
        <Tabs value={tabState} onChange={handleChangeTab} indicatorColor="primary" textColor="primary">
          <Tab label="All Member" value="all" />
          <Tab label="New Regist" value="new" />
        </Tabs>
        <TabPanel value={tabState} index="all">
          <AllMember />
        </TabPanel>
        <TabPanel value={tabState} index="new">
          <NewMember />
        </TabPanel>
      </Box>
    </Layout>
  )
}

export default Index
